<template>
    <div class="privateWaybill">
      <!-- <private-waybill-tabs></private-waybill-tabs> -->
      <private-waybill-container></private-waybill-container>
    </div>
</template>
<script>
// import PrivateWaybillTabs from '@/components/privateWaybill/Tabs.vue'
import PrivateWaybillContainer from '@/components/privateWaybill/Container.vue'
export default {
  name: 'privateWaybill',
  components: {
    // PrivateWaybillTabs,
    PrivateWaybillContainer
  }
}
</script>
<style lang="stylus">
.privateWaybill
  height 100%
</style>
